import React from 'react';

const TimelineLegend: React.FC = () => {
    return (
        <div className="absolute right-1 top-2 p-2 border border-gray-300 shadow-sm rounded-md z-10">
            <ul className="text-sm text-gray-600 space-y-2">
                <li className="flex items-center">
                    <span className="inline-block w-5 border-t-2 border-blue-500 mr-2"></span>
                    <span>Consecutive Events</span>
                </li>
                <li className="flex items-center">
                    <span className="inline-block w-5 border-t-2 border-dashed border-blue-500 mr-2"></span>
                    <span>Skipped Events</span>
                </li>
            </ul>
        </div>
    );
};

export default TimelineLegend;
